export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq4c-Alerts-MultiUser-Filled.d07e54e2.png";